import {createContext} from "react";


export const RestaurantContext = createContext<any>({
    restaurant: '',
    setRestaurant: () => {},
});